import posthog from 'posthog-js';

export function usePostHog() {
  posthog.init('phc_Ylha2ktDJnVee4pNtpL4L1t46QP6Fhu44nWetgarwlq', {
    api_host: 'https://us.i.posthog.com',
    capture_pageview: true,
  });

  return {
    posthog,
  };
}
